import { useTranslation } from 'react-i18next';

const pick = (vehicle, field, isFr) => (isFr ? vehicle[field] : vehicle[`${field}_en`] || vehicle[field]) || '';

export const hasCarfaxReport = (v) => Boolean(v?.carfax_report_url || v?.carfax_report_url_en || v?.carfax_badges_image_url || v?.carfax_badges_image_url_en);

export const isCarfaxAccidentFree = (v) => Array.isArray(v?.carfax_badges) && v.carfax_badges.includes('AccidentFree');

export const isCarfaxOneOwner = (v) => Array.isArray(v?.carfax_badges) && v.carfax_badges.includes('OneOwner');

const LOGO = 'https://res.cloudinary.com/dtqyyb6su/image/upload/v1774544534/entrepot/assets/carfax_logo_svg.svg';
const ACCIDENT_FREE = 'https://res.cloudinary.com/dtqyyb6su/image/upload/v1774544536/entrepot/assets/carfax_accident_free_svg.svg';
const ONE_OWNER = 'https://res.cloudinary.com/dtqyyb6su/image/upload/v1774544538/entrepot/assets/carfax_one_owner_svg.svg';

export const CarfaxReport = ({ vehicle, height = 42, className = '' }) => {
  const { i18n } = useTranslation();
  const isFr = !(i18n.language || 'fr').startsWith('en');
  const url = pick(vehicle, 'carfax_report_url', isFr);
  const img = pick(vehicle, 'carfax_badges_image_url', isFr);
  const clean = isCarfaxAccidentFree(vehicle);
  const oneOwner = isCarfaxOneOwner(vehicle);
  if (!url && !img && !clean && !oneOwner) return null;
  const alt = isFr ? 'Rapport CARFAX Canada' : 'CARFAX Canada report';
  const style = { height, width: 'auto', maxWidth: '100%', objectFit: 'contain' };
  const badgeStyle = { ...style, height: Math.round(height * 0.8) };
  // CARFAX's own badge image already contains the logo + badges; otherwise show our logo + badges once
  const image = img ? (
    <img src={img} alt={alt} loading="lazy" style={style} data-testid="carfax-badges-image" />
  ) : (
    <span className="flex flex-wrap items-center gap-2">
      <img src={LOGO} alt={alt} loading="lazy" style={style} data-testid="carfax-logo" />
      {clean && <img src={ACCIDENT_FREE} alt={isFr ? 'Aucun accident rapporté' : 'No reported accidents'} loading="lazy" style={badgeStyle} data-testid="carfax-accident-free" />}
      {oneOwner && <img src={ONE_OWNER} alt={isFr ? 'Un propriétaire' : 'One owner'} loading="lazy" style={badgeStyle} data-testid="carfax-one-owner" />}
    </span>
  );
  const stop = (e) => e.stopPropagation();
  return (
    <div className={`flex flex-col items-start gap-1.5 min-w-0 ${className}`} data-testid="carfax-report">
      {url ? (
        <a href={url} target="_blank" rel="noopener noreferrer" onClick={stop} className="block max-w-full" data-testid="carfax-badges-link">{image}</a>
      ) : image}
    </div>
  );
};
